import moment from 'moment';

const formatIncompleteHour = (time) => {
  return (
    (time.length === 1 && `0${time}:00`) ||
    (time.length === 3 && `${time}00`) ||
    (time.length === 4 && `${time}0`) ||
    (time.length === 5 && time)
  );
};

const checkIfRealHour = (time) => {
  const [hours, minutes] = time.split(':');

  return hours < 24 && minutes < 60;
};

const editDateMonthAndYearFromMoment = (momentDateTime, stringDateTime) => {
  const momentStringDateTime = moment(stringDateTime);

  const date = momentDateTime.get('date');
  const month = momentDateTime.get('month');
  const year = momentDateTime.get('year');

  momentStringDateTime.set({
    date,
    month,
    year,
  });

  return moment.utc(momentStringDateTime).format();
};

const editHourAndMinuteFromString = (stringDateTime, { hour, minute }) => {
  const momentStringDateTime = moment(stringDateTime);

  momentStringDateTime.set({
    hour,
    minute,
  });

  return moment.utc(momentStringDateTime).format();
};

export {
  formatIncompleteHour,
  checkIfRealHour,
  editDateMonthAndYearFromMoment,
  editHourAndMinuteFromString,
};
